var app_advertisers_table = $('#app-advertisers-table');

if (app_advertisers_table.length) {
    var data_table_order = [0, "asc"];
    function initializeAdvertisersTable(reload) {
        window.app_advertisers_table
            .DataTable({
                ajax: {
                    url: '/advertisers/',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'id'},//0
                    {data: 'name'},//1
                    {data: 'brands'},//2
                    {data: 'created_at'},//3
                    {data: 'created_by_name'},//4
                    {data: 'assigned_to_user'},//5
                    {data: 'status'},//6
                    {data: 'slug'}//7
                ],
                order: data_table_order,
                pageLength: user_entries,
                destroy: true,
                "columnDefs": [
                    {
                        "targets": 6, // your column index
                        "orderable": true,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            let html = '';
                            let bgColor = '';
                            let icon = '';

                            const value = (rowData.approved_status || '').toLowerCase();
                            if (value === 'confirmed') {
                                icon = '<i class="fa fa-star"></i>'; // replace with preferred icon
                                bgColor = 'color: darkblue; '; // yellow
                            } else if (value === 'pending' || value === 'new business') {
                                icon = '<i class="fa fa-clock-o"></i>';
                                bgColor = 'color: darkorange; '; // orange
                            } else if (value === 'approved') {
                                icon = '<i class="fa fa-check-circle"></i>';
                                bgColor = 'color: darkgreen;'; // green
                            } else {
                                icon = '';
                                bgColor = '';
                            }
                            icon = '';

                            if(value === 'rejected')
                                html = `<div style="padding: 4px 8px; border-radius: 6px;  color: darkred">Rejected</div>`;
                            else if(user.id === rowData.assigned_to && value === 'new business')
                                html = '<button class="btn-sm btn-primary btn-outline request-advertisers" data-id="' + rowData.id + '">Request Approval</button>'
                            else if((user.id === rowData.manager && value === 'pending') || (is_admin && value === 'pending'))
                                html = '<button class="btn-sm btn-primary btn-outline approve-advertisers" data-id="' + rowData.id + '">Approve/ Reject</button>'
                            else
                                html = `<div style="padding: 4px 8px; border-radius: 6px;  ${bgColor}">${icon} ${rowData.status}</div>`;

                            $(td).html(html);
                        }
                    },
                    {
                        "targets": 5,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            $(td).html(rowData.assigned_to_user !== null ? rowData.assigned_to_user['name'] : '');
                        }
                    },
                    {
                        "targets": 7,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            // var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                            //     '<a data-toggle="tooltip" data-original-title="Edit" data-placement="top" href="/advertisers/' +
                            //     cellData +
                            //     '" role="button" class="btn btn-success btn-sm">' +
                            //     '<i class="fa fa-pencil"></i>' +
                            //     '</a>' +
                            //     '<a data-toggle="tooltip" data-original-title="New Avail" data-placement="top" href="/advertisers/' +
                            //     cellData +
                            //     '/campaigns/list?new" role="button" class="btn btn-info btn-sm">' +
                            //     '<i class="fa fa-plus"></i>' +
                            //     '</a>' +
                            //     '<a data-toggle="tooltip" data-original-title="Delete" data-placement="top" href="javascript:void(0)" onclick="deleteAdvertiser(\'/advertisers/' + cellData + '/destroy\')" role="button" class="btn btn-danger btn-sm">' +
                            //     '<i class="fa fa-trash-o"></i>' +
                            //     '</a></div></div>';

                            const value = (rowData.approved_status || '').toLowerCase();

                            var html = '<div class="btn-group">\n' +
                                '            <button type="button" class="btn btn-outline btn-success waves-effect waves-light m-r-5 btn-off" data-toggle="dropdown">\n' +
                                '                <i class="fa fa-ellipsis-v"></i>\n' +
                                '                <span class="sr-only">Toggle Dropdown</span>\n' +
                                '            </button>\n' +
                                '            <ul class="dropdown-menu dropdown-menu-right">\n' +
                                '                <li class="ms-hover">' + '<a href="/advertisers/' + cellData + '" >' + '<i class="fa fa-pencil"></i> Edit' + '</a>' + '</li>\n' +
                                ((value === 'approved') ? '                <li class="ms-hover">' + '<a href="/campaigns/new?advertiser=' + cellData + '">' + '<i class="fa fa-plus"></i> New Avail' + '</a>' + '</li>\n' : '') +
                                '                <li class="ms-hover">' + '<a href="javascript:void(0)" onclick="deleteAdvertiser(\'/advertisers/' + cellData + '/destroy\')" >' + '<i class="fa fa-trash-o"></i> Delete' + '</a>' + '</li>\n' ;

                            //CNA Form
                            if(value === 'approved' || value === 'confirmed') {
                                html += '<li class="dropdown-submenu ">' + '<a class="" href="javascript:void(0)" data-name="' + rowData.name + '" data-id="' + cellData + '" >' + '<i class="fa fa-superpowers"></i> CNA Form' + '</a>' + '' +
                                    ' <ul class="dropdown-menu pull-left dropdown-menu-right" style="background-color: #30343C"> ';

                                if (rowData.lead_id !== null) {
                                    html += '<li class="ms-hover">' + '<a class="edit-cna_form" href="#" data-id="' + rowData.lead_id + '">' + '<i class="fa fa-pencil"></i> Edit  ' + '</a>' + '</li>\n';
                                    html += '<li class="ms-hover">' + '<a class="download-cna_form" href="#" data-id="' + rowData.lead_id + '">' + '<i class="fa fa-download"></i> Download' + '</a>' + '</li>\n';
                                    html += '<li class="ms-hover">' + '<a class="send-cna_form" href="#" data-id="' + rowData.lead_id + '">' + '<i class="fa fa-envelope"></i> Send ' + '</a>' + '</li>\n';

                                } else
                                    html += '<li class="ms-hover">' + '<a class="see-cna_form" href="javascript:void(0)" data-name="' + rowData.name + '" data-id="' + rowData.id + '" >' + '<i class="fa fa-plus"></i> Create (from Template)</a> </li>\n';
                                html += '</ul></li>\n';
                            }
                            html += '<li class="ms-hover">' + '<a class="" href="/advertisers/' + cellData + '?tab=1" >' + '<i class="fa fa-money"></i> Revise Proposal</a> </li>\n';
                            html +=  '           <li role="separator" class="divider ms-hover"></li>\n' +
                                '                <li class="ms-hover"><a href="javascript::;"></a></li>\n' +
                            '            </ul>\n' +
                            '        </div>';


                            $(td).html(html);
                        }
                    }, {
                        "targets": 3,
                        "orderable": true,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
                            $(td).html(date.format("MMM. D, YYYY"));
                        }
                    }, {
                        "targets": 1,
                        "orderable": true,
                        "createdCell": function (td, cellData, rowData, row, col) {
                          var html = "<a alt='" +cellData + "' href='/advertisers/" +rowData.slug + "'>" + cellData + (rowData.buyer_agency !== null && rowData.buyer_agency.advertiser_id === rowData.id ? ' (Direct)' : '') + "</a>";
                            $(td).html(html.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                        }
                    },
                    {
                        "targets": 2,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            $(td).html('');
                            $.each(cellData, function (index, value) {
                                $(td).append(value['name']);
                                if (index != (cellData.length - 1)) {
                                    $(td).append(' / ');
                                }
                            });
                        }
                    },
                    {
                        "targets": 0,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            var html = ' <div class="checkbox checkbox-danger advertisers_check"> <input class="checkbox" class="form-control" type="checkbox"  id="' + cellData + '" name="selected_advertisers[]" value="' + cellData + '" ><label for="'+ cellData +'"> </label></div>';

                            $(td).html(html);
                        }
                    },
                ]
            });

        $('#app-advertiser-table').on('click', '.request-advertisers', function () {
            var adv_id = $(this).attr('data-id');
            show_loader();
            $.ajax({
                type: 'GET',
                url: '/adv-request-approval/' + adv_id,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    global_notification('success', 'Advertiser request approval sent ...');
                    $('#app-advertisers-table').DataTable().ajax.url('/advertisers').load();
                    hide_loader();
                },
                error: function (xhr) {
                    ajax_error();
                    hide_loader();
                    debug(xhr.responseText);
                }
            });
        })

        $('#approve_advertiser_conf').on('click', function (){
            var agency_id = $(this).attr('data-id');
            var params = {
                id : agency_id,
                comments : $('#buyer_advertiser_approve_deny_comments').val(),
                action: 'approve',
            };
            approve_deny_advertiser(params)
        });
        $('#deny_advertiser_conf').on('click', function (){
            var agency_id = $(this).attr('data-id');
            var params = {
                id : agency_id,
                comments : $('#buyer_advertiser_approve_deny_comments').val(),
                action: 'deny',
            };
            approve_deny_advertiser(params)
        });

        function approve_deny_advertiser(params) {
            show_overlay_loader($('#ApproveDenyBuyerAdvertiserModal'));
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/advertiser/approve_or_deny/new_business',
                dataType: "json",
                contentType: "application/json",
                success: function (data) {
                    var text = params.action === 'deny' ? 'Rejected' : 'Approved';
                    global_notification('success', 'Advertiser '+ text +' successfully ...');
                    $('#app-advertisers-table').DataTable().ajax.url('/advertisers').load();
                    $('#ApproveDenyBuyerAdvertiserModal').modal('hide');
                    hide_overlay_loader($('#ApproveDenyBuyerAdvertiserModal'));
                },
                error: function (xhr) {
                    ajax_error();
                    hide_loader();
                    debug(xhr.responseText);
                    hide_overlay_loader($('#ApproveDenyBuyerAdvertiserModal'));
                }
            });
        }

        $('#app-advertisers-table').on('click', '.approve-advertisers', function () {
            $('#approve_advertiser_conf').attr('data-id', $(this).attr('data-id'));
            $('#deny_advertiser_conf').attr('data-id', $(this).attr('data-id'));
            $('#ApproveDenyBuyerAdvertiserModal').modal('show');
        })

        setTimeout(() => {
            $(function () {
                $('[data-toggle="tooltip"]').tooltip();
            });
        }, 3000);


        if(reload)
            location.reload();
    }

    var app_advertisers_table_archived = $('#app-advertisers-table-archived').DataTable({
        ajax: {
            url: '/advertisers/archived',
            dataSrc: 'data'
        },
        columns: [
            {data: 'id'},//0
            {data: 'name'},//1
            {data: 'archive_by'},//2
            {data: 'deleted_at'},//3
            {data: 'created_at'},//4
            {data: 'id'},//5
        ],
        //    order: data_table_order,
        pageLength: user_entries,
        "columnDefs": [
            {
                "targets": 5,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                        '<a href="javascript:void(0)" '+
                        ' role="button" class="btn btn-primary btn-sm btn-outline see_campaigns" data-id="'+ cellData +'" data-name="'+ rowData.name +'">' +
                        '<i class="fa fa-eye"></i> See Avails</a></div>' ;

                    $(td).html(html);
                }
            },
            {
                "targets": 4,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    console.log('rowData ', rowData);
                    date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
                    $(td).html(date.format("MMM. D, YYYY"));
                }
            },
            {
                "targets": 3,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
                    $(td).html(date.format("MMM. D, YYYY"));
                }
            },
            {
                "targets": 0,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    var html = ' <div class="checkbox checkbox-danger advertisers_check_archived"> <input class="checkbox" class="form-control" type="checkbox"  id="' + cellData + '" name="selected_advertisers[]" value="' + cellData + '" ><label for="' + cellData + '"> </label></div>';

                    $(td).html(html);
                }
            },
        ]
    });

    $('#app-advertisers-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries= len;
    });
    $('#app-advertisers-table').on( 'order.dt', function ( e, settings, len) {
        data_table_order=[len[0].col, ""+len[0].dir+""];
    } );
    $('#app-advertisers-table-archived').on( 'length.dt', function ( e, settings, len ) {
        user_entries= len;
    });
    $('#app-advertisers-table-archived').on( 'order.dt', function ( e, settings, len) {
        data_table_order=[len[0].col, ""+len[0].dir+""];
    } );


    function deleteAdvertiser(urlVar) {
        $('#deletedAdvConfirm').attr('data-url', urlVar);
        $('#deleteAdvWarningModal').modal('show');
    }
    function deletedAdvConfirm(){
        show_loader();
        var urlVar =  $('#deletedAdvConfirm').attr('data-url');
        $.ajax({
           url: urlVar,
           success: function (response) {
               global_notification('success', 'Advertiser deleted');
               $('#deleteAdvWarningModal').modal('hide');
               initializeAdvertisersTable(true);
               hide_loader();
           },
           error: function (xhr) {
               debug(xhr.responseText);
               hide_loader();
           }
       });
   }

    initializeAdvertisersTable(finish);

    $('#select_all_adv').on('click', function (e) {
        $('#app-advertisers-table input:checkbox').prop('checked', true);
    });
    $('#deselect_all_adv').on('click', function (e) {
        $('#app-advertisers-table input:checkbox').prop('checked', false);
    });
    $('#select_all_adv_archived').on('click', function (e) {
        $('#app-advertisers-table-archived input:checkbox').prop('checked', true);
    });
    $('#deselect_all_adv_archived').on('click', function (e) {
        $('#app-advertisers-table-archived input:checkbox').prop('checked', false);
    });

    $('#archive_adv').on('click', function (){
        var selectedItems = [];
        $('.advertisers_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var text = selectedItems.length > 0 ? 'All the avails under these advertisers will be archived. Are you sure to continue?' : 'Please select at least one advertiser first.';
        $('#generalWarningModalDiv').html(text);
        $('#ok_got_it').hide();
        $('#archive_advertiser_confirm').hide();
        $('#activate_advertiser_confirm').hide();
        $('#delete_advertiser_confirm').hide();
        if(selectedItems.length > 0)
            $('#archive_advertiser_confirm').show();
        else
            $('#ok_got_it').show();
        $('#generalWarningModal').modal('show');
    });

    $('#delete_adv').on('click', function (){
        var selectedItems = [];
        $('.advertisers_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var text = selectedItems.length > 0 ? 'All the avails under these advertisers will be deleted. Are you sure to continue?' : 'Please select at least one advertiser first.';
        $('#generalWarningModalDiv').html(text);
        $('#ok_got_it').hide();
        $('#archive_advertiser_confirm').hide();
        $('#activate_advertiser_confirm').hide();
        $('#delete_advertiser_confirm').hide();
        if(selectedItems.length > 0)
            $('#delete_advertiser_confirm').show();
        else
            $('#ok_got_it').show();
        $('#generalWarningModal').modal('show');
    });

    $('#archive_advertiser_confirm').on('click', function (){
        show_overlay_loader($('#generalWarningModal .modal-content'));
        var selectedItems = [];
        $('.advertisers_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var params = {
            advertisers: selectedItems,
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/advertisers/archive',
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                hide_overlay_loader($('#generalWarningModal .modal-content'));
                window.location.reload();
            },
            error: function (xhr) {
                hide_overlay_loader($('#generalWarningModal .modal-content'));
                ajax_error();
                debug(xhr.responseText);

            }
        });

    });

    $('#app-advertisers-table-archived').on('click', '.see_campaigns',function () {
        var id = $(this).attr('data-id');
        var name = $(this).attr('data-name');
        $('#myModalLabelTitle_camp').html(name + "'s Avails");
        $.ajax({
            type: 'GET',
            url: '/advertisers/archived/see_campaigns/' + id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                gridArchivedInvCampaigns.rowData = [];
                gridArchivedInvCampaigns.rowData = data;

                $('#seeCampaignsGridDiv').html("");
                var gridArchivedInvCampaignsGrid = document.querySelector('#seeCampaignsGridDiv');
                var g5 = new agGrid.Grid(gridArchivedInvCampaignsGrid, gridArchivedInvCampaigns);

                $('#seeCampaignsModal').modal({backdrop: 'static', keyboard: false})
                $('#seeCampaignsModal').modal('show');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });

    });
    var columnArchivedInvCampaigns = [
        {
            headerName: "Campaign Name",
            field: 'name',
            width: 280,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Date Range",
            field: 'date_range',
            width: 180,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Estimate #",
            field: 'estimate_number',
            width: 150,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Brand",
            field: 'brand_name',
            width: 150,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Product",
            field: 'product_name',
            width: 150,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Created at",
            field: 'created_at_string',
            width: 150,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Created By",
            field: 'created_by',
            width: 150,
            cellStyle: {'text-align': "left"},
        },

    ];
    var gridArchivedInvCampaigns = {
        columnDefs: columnArchivedInvCampaigns,
        defaultColDef: {
            suppressToolPanel: true
        },
        autoGroupColumnDef: {
            headerName: 'Invoice',//custom header name for group
            pinned: 'left',//force pinned left. Does not work in columnDef
            suppressMovable: true,
            suppressFilter: false,
            cellRendererParams: {
                suppressCount: false,//remove number in Group Column
                suppressMovable: true,
                suppressFilter: false,
            }
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
    };


    $('#activate_adv').on('click', function (){
        var selectedItems = [];
        $('.advertisers_check_archived input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var text = selectedItems.length > 0 ? 'All the avails under these advertisers will be activated. Are yo sure to continue?' : 'Please select at least one adveriser first.';
        $('#generalWarningModalDiv').html(text);
        $('#ok_got_it').hide();
        $('#archive_advertiser_confirm').hide();
        $('#activate_advertiser_confirm').hide();
        if(selectedItems.length > 0)
            $('#activate_advertiser_confirm').show();
        else
            $('#ok_got_it').show();
        $('#generalWarningModal').modal('show');
    });

    $('#activate_advertiser_confirm').on('click', function (){
        show_overlay_loader($('#generalWarningModal .modal-content'));
        var selectedItems = [];
        $('.advertisers_check_archived input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var params = {
            advertisers: selectedItems,
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/advertisers/activate',
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                hide_overlay_loader($('#generalWarningModal .modal-content'));
                window.location.reload();
            },
            error: function (xhr) {
                hide_overlay_loader($('#generalWarningModal .modal-content'));
                ajax_error();
                debug(xhr.responseText);

            }
        });

    });

    $('#delete_advertiser_confirm').on('click', function (){
        show_overlay_loader($('#generalWarningModal .modal-content'));
        var selectedItems = [];
        $('.advertisers_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var params = {
            advertisers: selectedItems,
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/advertisers/archive',
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                hide_overlay_loader($('#generalWarningModal .modal-content'));
                window.location.reload();
            },
            error: function (xhr) {
                hide_overlay_loader($('#generalWarningModal .modal-content'));
                ajax_error();
                debug(xhr.responseText);

            }
        });

    });

    //CNA Forms
    var gridCNATemplatesColumnDef = [
        {
            headerName: "Name",
            field: 'title',
            width: 200,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Created By",
            field: 'created_by',
            width: 120,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Created At",
            field: 'created_at',
            width: 140,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Descrption",
            field: 'description',
            width: 300,
            cellStyle: {'text-align': "left"},
        },
        {
            field: 'see',
            headerName: "",
            width: 50,
            cellStyle: {'text-align': "right"},
            cellRenderer: function (params) {
                var html = '';
                var value = params.data.see;
                html += " <span style='margin-bottom: 20%'>" +
                    "<a style='background-color: white; color: dimgray; font-size: 13px' title='Click to create a CNA form using this template' class='see_cna_template' type='button' data-id='" + value + "'  href='#'>" +
                    "<i style='color: darkred; font-weight: bolde…nt-weight: bolder; text-align: center; ' class='fa fa-plus-square'></i></a>";

                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                this.eGui = tempDiv.firstElementChild;
                return this.eGui;
            },
        },
        {
            field: 'download',
            headerName: "",
            width: 50,
            cellStyle: {'text-align': "right"},
            cellRenderer: function (params) {
                var html = '';
                var value = params.data.see;
                html += " <span style='margin-bottom: 20%'>" +
                    "<a style='background-color: white; color: dimgray; font-size: 13px' title='Click to export this Template to PDF' class='download_cna_template' type='button' data-id='" + value + "'  href='#'>" +
                    "<i style='color: #1b6d85; font-weight: bolde…nt-weight: bolder; text-align: center; ' class='fa fa-file-pdf-o'></i></a>";

                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                this.eGui = tempDiv.firstElementChild;
                return this.eGui;
            },
        },
    ];
    var gridCNATemplates = {
        columnDefs: gridCNATemplatesColumnDef,
        defaultColDef: {
            suppressToolPanel: true,
            resizable: true
        },
        rowSelection: 'single',
        suppressRowClickSelection: true,
        enableColResize: true,
        suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 25,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 25,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 3,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        // getContextMenuItems : getContextMenuItemsOrderLine,
    };

    $('#app-advertisers-table').on('click', '.see-cna_form', function (){
        var agency_id = $(this).attr('data-id');
        var agency_name = $(this).attr('data-name');
        $('#save_cna_form_for_by').val(agency_id);
        $('#save_cna_form_for_by').attr('data-agency-name', agency_name);
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/cna/get-lead-form/buyer_agency/' + agency_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('.existing_cna_form_div').html('No CNA Form is currently associated with this Advertiser. Please use a template to create one.');
                $('.BuyerAgencyCNATitle').html(agency_name + ' CNA Form');
                gridCNATemplates.rowData = [];
                gridCNATemplates.rowData = data.template;
                $('#cnaFormTemplateListGridDiv').html('');
                var gridCNATemplatesD = document.querySelector('#cnaFormTemplateListGridDiv');
                var g5 = new agGrid.Grid(gridCNATemplatesD, gridCNATemplates);
                $('#CNAFormTemplateModal').modal('show')
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });

    var hidden_fields_gl = [];
    var oldValueSelected = '';
    var last_index_array = {};
    var questions_names_gl = {};
    var template_selected_id = '';
    $('#cnaFormTemplateListGridDiv').on('click', '.see_cna_template', function () {
        var template_id = $(this).attr('data-id');
        hidden_fields_gl = [];
        last_index_array = {};
        questions_names_gl = {};
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/cna/template/see_form/' + template_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                template_selected_id = template_id;
                load_form('create', data);
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });

    $('#app-advertisers-table').on('click', '.edit-cna_form', function () {
        var form_id = $(this).attr('data-id');
        var agency_name = $(this).attr('data-name');
        $('#update_cna_form_for_by').val(form_id);
        $('#update_cna_form_for_by').attr('data-agency-name', agency_name);
        hidden_fields_gl = [];
        last_index_array = {};
        questions_names_gl = {};
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/cna/lead/edit/' + form_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                load_form('udpate', data);
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });

    function load_form(from, data){
        $('.div_to_show_form').html('');
        $('.div_to_show_form').html(data.html);
        hidden_fields_gl = data.hidden_class;
        last_index_array = data.index_by_tab;
        questions_names_gl = data.questions_names;
        for (var ind in data.select2_fields){
            var input = data.select2_fields[ind];

            var isMultiple = $("#CNAFormModal .div_to_show_form  #" + input).prop('multiple');
            if(isMultiple === true) {
                $("#CNAFormModal .div_to_show_form  #" + input).select2({
                    minimumResultsForSearch: 100,
                    placeholder: 'Select at least one....',
                }).on('select2:select', function (e) {
                    let selectedValue = e.params.data.id;
                    var selectedOption = e.params.data.element;
                    var dataId = $(selectedOption).data('id');
                    var div_index = $(this).attr('data-tab') + '_' + $(this).attr('data-ind') + '_' + dataId;
                    if (hidden_fields_gl.indexOf(div_index) !== -1)
                        $("#CNAFormModal .div_to_show_form ." + div_index).show();
                }).on('select2:unselect', function (e) {
                    let selectedValue = e.params.data.id;
                    var selectedOption = e.params.data.element;
                    var dataId = $(selectedOption).data('id');
                    var div_index = $(this).attr('data-tab') + '_' + $(this).attr('data-ind') + '_' + dataId;
                    if (hidden_fields_gl.indexOf(div_index) !== -1)
                        $("#CNAFormModal .div_to_show_form  ." + div_index).hide();

                });
            }else{
                $("#CNAFormModal .div_to_show_form  #" + input).select2({
                    minimumResultsForSearch: 100,
                    placeholder: 'Select one....',
                }).on('select2:opening', function () {
                    oldValueSelected = $(this).find('option:selected').attr('data-id'); // Store current value before change
                }).on('change', function (e) {
                    const selectedOption = $(this).find('option:selected');
                    const dataId = selectedOption.attr('data-id'); // gets the value of data-id
                    const selectedValue = selectedOption.val();

                    const div_index = $(this).attr('data-tab') + '_' + $(this).attr('data-ind') + '_' + dataId;
                    const class_index = $(this).attr('data-tab') + '_' + $(this).attr('data-ind') + '_' + oldValueSelected;

                    $("#CNAFormModal .div_to_show_form ."+ class_index).hide();
                    console.log('hidden_fields_gl ', hidden_fields_gl)
                    console.log('hide ', class_index)
                    console.log('show ', div_index)

                    if (hidden_fields_gl.indexOf(div_index) !== -1) {
                        $("#CNAFormModal .div_to_show_form ." + div_index).show();
                    }
                })
            }
        }
        if(from == 'create'){
            $('.save_cna_form_for_by').show();
            $('.update_cna_form_for_by').hide();
        }else{
            $('.save_cna_form_for_by').hide();
            $('.update_cna_form_for_by').show();
        }
        $('#CNAFormModal').modal({backdrop: 'static', keyboard: false});
        $('#CNAFormModal').modal('show')
        hide_loader();
    }

    $('#cnaFormTemplateListGridDiv').on('click', '.download_cna_template', function () {
        var link = document.createElement('a');
        var id = $(this).attr('data-id');
        link.href = "/cna/form/" + id + '/download';
        $(link).attr('target', '_blank');
        link.click();
    });

    $('.save_cna_form_for_by').on('click', function (){
        show_overlay_loader($('#CNAFormModal'));
        $('#agency_id_cna').val($('#save_cna_form_for_by').val());
        $('#template_selected_id_cna').val(template_selected_id);
        var agency_name = $('#save_cna_form_for_by').attr('data-agency-name');
        $('#last_index_array').val(JSON.stringify(last_index_array));
        $('#questions_names_gl').val(JSON.stringify(questions_names_gl));
        var data = $('#cna_dynamic_form_ba').serializeArray();
        var button_id = $(this).attr('id');
        $.ajax({
            type: 'POST',
            url: '/lead_cna/store',
            data: data,
            dataType: 'json',
            encode: true,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                global_notification('success', 'CNA Form created for this Advertiser...');
                $('#app-advertisers-table').DataTable().ajax.url('/advertisers').load();
                if(button_id === 'save_and_show_cna_form_for_by'){
                    var id = data.id;
                    var link = document.createElement('a');
                    link.href = "/lead/cna_form/" + id + '/download';
                    $(link).attr('target', '_blank');
                    link.click();
                }
                $('#CNAFormModal').modal('hide');
                $('#CNAFormTemplateModal').modal('hide');
                hide_overlay_loader($('#CNAFormModal'));
            },
            error: function (xhr) {
                debug(xhr.responseText);
                ajax_error();
                hide_overlay_loader($('#CNAFormModal'));
            }
        });

    });

    $('.update_cna_form_for_by').on('click', function (){
        show_overlay_loader($('#CNAFormModal'));
        $('#agency_id_cna').val($('#update_cna_form_for_by').val());
        var agency_name = $('#update_cna_form_for_by').attr('data-agency-name');
        $('#last_index_array').val(JSON.stringify(last_index_array));
        $('#questions_names_gl').val(JSON.stringify(questions_names_gl));
        var data = $('#cna_dynamic_form_ba').serializeArray();
        var button_id = $(this).attr('id');
        $.ajax({
            type: 'POST',
            url: '/lead_cna/update',
            data: data,
            dataType: 'json',
            encode: true,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                global_notification('success', 'CNA Form updated ...');
                $('#app-advertisers-table').DataTable().ajax.url('/advertisers').load();
                if(button_id === 'update_and_show_cna_form_for_by'){
                    var id = data.id;
                    var link = document.createElement('a');
                    link.href = "/lead/cna_form/" + id + '/download';
                    $(link).attr('target', '_blank');
                    link.click();
                }
                $('#CNAFormModal').modal('hide');
                $('#CNAFormTemplateModal').modal('hide');
                hide_overlay_loader($('#CNAFormModal'));
            },
            error: function (xhr) {
                debug(xhr.responseText);
                ajax_error();
                hide_overlay_loader($('#CNAFormModal'));
            }
        });

    });

    $('#app-advertisers-table').on('click', '.download-cna_form' ,function (){
        var id = $(this).attr('data-id');
        var link = document.createElement('a');
        link.href = "/lead/cna_form/" + id + '/download';
        $(link).attr('target', '_blank');
        link.click();
    });
    $('#app-advertisers-table').on('click', '.send-cna_form' ,function (){
        var id = $(this).attr('data-id');
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/cna/lead/send_by_email/' + id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#send_cna_form_email').val(id);
                $('.manager_email').html('');
                $('.manager_email').html(data.html);
                if(data.manager !== null && data.manager.email != '' && data.manager.email != null)
                    $('#send_cna_form_email').show();
                else
                    $('#send_cna_form_email').hide();

                $('#CNASendByEmailModal').modal('show');

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });

    });
    $('#send_cna_form_email').on('click', function (){
        var params = {
            lead_id: $(this).val(),
            copy: $("input:checkbox[name=send_me_copy]:checked").attr('value'),
        }
        show_overlay_loader($('#CNASendByEmailModal'));
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/cna/lead/send/manager_email',
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                var error_show = false;
                if (typeof data['errorEmails'] !== undefined && data['errorEmails'] !== null && typeof data['errorEmails'][0] !== 'undefined')
                    error_show = data['errorEmails'][0].indexOf('@fmbcmail.com') !== - 1 || data['errorEmails'][0].indexOf('@sbgtv.com') !== -1 ? false : true;
                if ( typeof data['errorEmails'] !== undefined && data['errorEmails'] !== null && error_show === true)
                    global_notification('error', 'The following contacts did not receive the CNA Form: (' + data['errorEmails'].join() + '). Please check their email addresses and re-send.', 35000);
                else {
                    global_notification('success', 'Email sent succefully ...');
                    $('#CNASendByEmailModal').modal('hide');
                }

                hide_overlay_loader($('#CNASendByEmailModal'));
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
                hide_overlay_loader($('#CNASendByEmailModal'));
            }
        });
    });
}
